import type { MapChangeSnapshot, MapNoteChangeKind } from "@west-marches/shared";
import type { Hex } from "@west-marches/shared";

type BroadcastMapChangeFn = (snapshot: MapChangeSnapshot) => void;
type BroadcastPartyMoveFn = (target: Hex) => void;
type BroadcastMapNoteChangeFn = (mapNoteId: string, kind: MapNoteChangeKind) => void;

const noop = () => {};

let _broadcastMapChange: BroadcastMapChangeFn = noop;
let _broadcastPartyMove: BroadcastPartyMoveFn = noop;
let _broadcastMapNoteChange: BroadcastMapNoteChangeFn = noop;

export function setBroadcastMapChange(fn: BroadcastMapChangeFn) {
  _broadcastMapChange = fn;
}

export function setBroadcastPartyMove(fn: BroadcastPartyMoveFn) {
  _broadcastPartyMove = fn;
}

export function setBroadcastMapNoteChange(fn: BroadcastMapNoteChangeFn) {
  _broadcastMapNoteChange = fn;
}

export function getBroadcastMapChange(): BroadcastMapChangeFn {
  return _broadcastMapChange;
}

export function getBroadcastPartyMove(): BroadcastPartyMoveFn {
  return _broadcastPartyMove;
}

export function getBroadcastMapNoteChange(): BroadcastMapNoteChangeFn {
  return _broadcastMapNoteChange;
}
